export default function XSD_Mixed() {
  return (
    <div>
      <h1>XSD_Mixed</h1>
      <p>This is the XSD_Mixed component.</p>
    </div>
  );
}